import Handlebars from "../handlebars/handlebars";
import "../collaterateInfo/collaterateInfo";
import "../styleWidget/styleWidget";
import ContentBlock from "../contentBlock/ContentBlock";

new ContentBlock(document.querySelector('.js-element--globalMessage'), 'global-message');
